import React from 'react';

import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

import { TextInput } from 'ui/TextInput';
import { createFilterRegex } from 'utils/regex';

import { PickerProps } from '../types';

const TextInputInput: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => (
  <TextInput
    {...props}
    placeholder="Field Value"
    onChange={(event) => applyValue({ ...item, value: event.target.value })}
    value={(item.value as string) ?? ''}
  />
);

export default (): GridFilterOperator[] =>
  [
    {
      label: 'contains',
      value: 'contains',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!filterItem.value) {
          return null;
        }
        const filterItemValue = filterItem.value.trim();

        const filterRegex = createFilterRegex(filterItemValue);
        return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
      },
      InputComponent: TextInputInput,
      getValueAsString: (value: string) => value,
    },
  ] as unknown as GridFilterOperator[];
